<main class="page">

  @if (isLoading()) {
    <p class="text-secondary py-5 text-center">Loading...</p>
  } @else if (!request()) {
    <p class="text-danger py-5 text-center">Failed to load project data.</p>
  } @else {
    <!-- Title row -->
    <div class="page-header">
      <h1 class="page-title">CE Request · <span class="estimate-number">{{ request()!.estimateNumber }}</span></h1>
      <span [class]="'badge ' + statusClass(request()!.status)">● {{ request()!.status }}</span>
    </div>

    <!-- Step 1: Project Team -->
    <div class="details-card">
      <p class="details-card__subtitle">Step 1 · Project Team</p>
      <hr class="details-card__divider" />
      <div class="fields-grid">
        <div class="field-group">
          <label class="field-label">Estimate Number</label>
          <input class="field-input" type="text" [value]="request()!.estimateNumber" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Request Date</label>
          <input class="field-input" type="text" [value]="request()!.requestDate ? (request()!.requestDate | date: 'yyyy-MM-dd') : '-'" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Project Team</label>
          <input class="field-input" type="text" [value]="request()!.projectTeam" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">AFE No.</label>
          <input class="field-input" type="text" [value]="request()!.afeNumber" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Is New Project</label>
          <input class="field-input" type="text" [value]="request()!.isNewProject ? 'Yes' : 'No'" disabled />
        </div>
      </div>
    </div>

    <!-- Step 2: Project Details -->
    <div class="details-card">
      <p class="details-card__subtitle">Step 2 · Project Details</p>
      <hr class="details-card__divider" />
      <div class="fields-grid">
        <div class="field-group">
          <label class="field-label">Project Title</label>
          <input class="field-input" type="text" [value]="request()!.projectTitle" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Estimate Title</label>
          <input class="field-input" type="text" [value]="request()!.estimateTitle" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Project Number</label>
          <input class="field-input" type="text" [value]="request()!.projectNumber" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Project Code</label>
          <input class="field-input" type="text" [value]="request()!.projectCode" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Estimate Request Type</label>
          <input class="field-input" type="text" [value]="request()!.estimateRequestType" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Project Management Type</label>
          <input class="field-input" type="text" [value]="request()!.projectManagementType" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">CPDEP Phase</label>
          <input class="field-input" type="text" [value]="request()!.cpdepPhase" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Design Progress</label>
          <input class="field-input" type="text" [value]="request()!.designProgress" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Planned Project Completion Date</label>
          <input class="field-input" type="text" [value]="(request()!.anticipatedCompletionDate | date: 'yyyy-MM-dd') || request()!.anticipatedCompletionDate" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Area</label>
          <input class="field-input" type="text" [value]="request()!.area" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Unit</label>
          <input class="field-input" type="text" [value]="request()!.unit" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">Preliminary Cost Estimate Deadline</label>
          <input class="field-input" type="text" [value]="(request()!.preliminaryCostDeadline | date: 'yyyy-MM-dd') || request()!.preliminaryCostDeadline" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">IBP Year</label>
          <input class="field-input" type="text" [value]="request()!.ibp" disabled />
        </div>
        <div class="field-group">
          <label class="field-label">TA Year</label>
          <input class="field-input" type="text" [value]="request()!.taYear" disabled />
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="actions-row">
      <button class="btn-back" type="button" (click)="goBack()">‹ Back to My Requests</button>
      @if (canGoToQuestionnaire()) {
        <button class="btn-edit btn-questionnaire" type="button" (click)="goToQuestionnaire()">Go to Questionnaire</button>
      }
      @if (canGoToResponsePage()) {
        <button class="btn-edit btn-response" type="button" (click)="goToResponsePage()">Go to Response Page</button>
      }
      @if (canEditRequest()) {
        <button class="btn-edit" type="button" (click)="editRequest()">Edit</button>
      }
    </div>
  }

</main>
